export const APP_VERSION_URL = '/version.json'
export const APP_VERSION_POLL_MS = 5 * 60 * 1000
/** sessionStorage key prefix for dismissed remote builds */
export const DISMISS_PREFIX = 'do-chat-app-update-dismissed'
